export const dataHooks = {
  content: 'cardFolderTabs-content',
  header: 'cardFolderTabs-header',
  tabButton: id => `cardFolderTabs-tabButton-${id}`,
  tabText: id => `cardFolderTabs-tabText-${id}`,
};
